'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/row/style/css');

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _css2 = require('antd/lib/col/style/css');

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _home = require('../actions/home');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = _react2.default.createClass({
  displayName: 'Home',

  propTypes: {
    dispatch: _react.PropTypes.func.isRequired
  },
  componentDidMount: function componentDidMount() {
    var dispatch = this.props.dispatch;

    dispatch((0, _home.fetchDashBoardData)());
  },
  render: function render() {
    var count = this.props.counts.count;

    var data = count.order_status_stats,
        toUpload = 0,
        toDelivery = 0;
    data && data.forEach(function (i) {
      if (i.status === 2) {
        toUpload = i.total;
      } else if (i.status === 4) {
        toDelivery = i.total;
      }
    });
    return _react2.default.createElement(
      'div',
      { id: 'home' },
      _react2.default.createElement(
        _row2.default,
        null,
        _react2.default.createElement(
          _col2.default,
          { span: 12 },
          _react2.default.createElement(
            'strong',
            null,
            toUpload
          ),
          _react2.default.createElement(
            'p',
            null,
            '\u5F85\u4E0A\u4F20\u8BA2\u5355'
          )
        ),
        _react2.default.createElement(
          _col2.default,
          { span: 12 },
          _react2.default.createElement(
            'strong',
            null,
            toDelivery
          ),
          _react2.default.createElement(
            'p',
            null,
            '\u5F85\u53D1\u8D27\u8BA2\u5355'
          )
        )
      )
    );
  }
});

var mapStateToProps = function mapStateToProps(store) {
  var counts = store.home.counts;

  return {
    counts: counts
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Home);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/home.js
// module id = 1003
// module chunks = 0